import { PayPalCheckoutLoadPayPalSDKOptions } from 'braintree-web/paypal-checkout';

// Design System
import env from 'jl-design-system/utils/env/env';

// Types
import { PayPalType } from './PayPalButton.types';

// Config
import featureConstants from '@constants/featureConstants';
import paymentTypeConstants from '@constants/paymentTypeConstants';
import { getStorageItem } from '@utils/storage/storage';

export const PayPalTypes = {
  PayPal: 'paypal',
  Express: 'paypalExpress',
  PayLater: 'paypalPayLater',
};

export const paymentTypeConstantsMap: Record<PayPalType, string> = {
  paypal: paymentTypeConstants.PAYPAL,
  paypalExpress: paymentTypeConstants.PAYPAL_EXPRESS,
  paypalPayLater: paymentTypeConstants.PAYPAL_PAY_LATER,
};

export const getPayPalSdkOptions = ({ type }: { type: PayPalType }): PayPalCheckoutLoadPayPalSDKOptions => ({
  currency: 'GBP',
  intent: 'authorize',
  ...(type === PayPalTypes.PayLater && { 'enable-funding': 'paylater' }),
});

export const tokenHasJustBeenReceived = (previousState: string | undefined, currentState: string | undefined) =>
  !previousState && currentState;

export const isLocalPayPalSandbox = () =>
  getStorageItem(featureConstants.USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE, true) === 'true';

export const resolvePayPalClientToken = ({ payPalClientToken }: { payPalClientToken?: string }) =>
  isLocalPayPalSandbox() ? getStorageItem(featureConstants.PAYPAL_CLIENT_TOKEN_OVERRIDE, true) : payPalClientToken;

export const useRealPayPal = () => (!env.isClientLocal && !env.isClientDev) || isLocalPayPalSandbox();
